import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SelectInputTranslated from 'components/layout/forms/SelectInputTranslated';
import translations from 'services/translations/translations';
import {
  APPROVED,
  OFFER_STATUSES,
  OPEN,
  OPPORTUNITY_STATUSES,
  READY_TO_SEND,
  isConvertedStatus,
} from 'services/enums/offers/Statuses';
import { OPPORTUNITY } from 'services/enums/offers/offerTypes';
import { getStatusTranslationPath } from 'services/offers/offerStatusLabel';
import { fetchStatusTypes } from 'store/offers/actions';

const Status = ({
  disabled,
  formState,
  handleFormState,
  initialStatus,
  offerType,
  sent,
}: {
  // E.g. the user can only read the offer
  disabled?: boolean;
  formState: { status: string };
  handleFormState: any;
  initialStatus: null | string;
  offerType?: string;
  sent: boolean;
}): JSX.Element => {
  const { t } = useTranslation([translations.offers]);

  const dispatch = useDispatch();
  const statusTypes = useSelector((state: any) => state.offers.statusTypes);

  useEffect(() => {
    dispatch(fetchStatusTypes());
  }, []);

  const isOpportunity = offerType === OPPORTUNITY;

  // An approved offer and a converted opportunity are final
  const offerIsApproved =
    initialStatus === APPROVED || isConvertedStatus(initialStatus);

  // An opportunity has statuses of its own. A sent offer cannot be reopened, a new
  // revision has to be created instead.
  // The statuses of an opportunity in the order of its life: open, then the closings
  // The statuses of the offers in the order of their life: open, ready to send, sent,
  // ordered, rejected
  const options = isOpportunity
    ? OPPORTUNITY_STATUSES.filter((status) => statusTypes.includes(status))
    : OFFER_STATUSES.filter(
        (status) =>
          statusTypes.includes(status) &&
          !(sent && (status === OPEN || status === READY_TO_SEND))
      );

  return (
    <SelectInputTranslated
      disabled={offerIsApproved || disabled}
      key="status"
      label={t(`${translations.offers}:Status`)}
      name="status"
      onChange={handleFormState}
      options={options}
      required
      translationPath={getStatusTranslationPath(offerType, offerIsApproved)}
      value={formState.status}
    />
  );
};

export default Status;
